import { createSlice } from "@reduxjs/toolkit";

const pageSlice = createSlice({
  name: "pages",
  initialState: {
    pages: [],
    blogs: [],
    error: null,
    loading: false,
  },
  reducers: {
    getPagesAction: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPagesSuccess: (state, action) => {
      state.pages = action.payload || [];
      state.loading = false;
    },
    getPagesFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getBlogsAction: (state) => {
      state.loading = true;
      state.error = null;
    },
    getBlogsSuccess: (state, action) => {
      state.blogs = action.payload || [];
      state.loading = false;
    },
    getBlogsFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  getPagesAction,
  getPagesSuccess,
  getPagesFailure,
  getBlogsAction,
  getBlogsSuccess,
  getBlogsFailure,
} = pageSlice.actions;

export default pageSlice.reducer;
